/* 
  How to use me?

  <app-dutch-currency-field [model]="model" [fieldName]="field.name"></app-dutch-currency-field>

  model - should be an object
  fieldName - will be the expected property to be modified

  styles - you can update it depends on required UI
 */


import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-dutch-currency-field',
  templateUrl: './dutch-currency-field.component.html',
  styleUrls  : ['./dutch-currency-field.component.scss'],
  styles: [`
    :host {
      background-color: #c8c8cc4a;
      color: #969492;
      font-size: 18px;  
      width: 100%;
      padding: 12px 9px;
    }
  `]
})
export class DutchCurrencyFieldComponent implements OnInit {
  @ViewChild('inputRef', { read: ElementRef })  inputRef: ElementRef;
  @Input() model  = {}; //Inherited from parent component
  @Input() fieldName: string  = ''; //Field property name from parent

  inputValue: string;
  decimal = '.';
  decimalDutch = ',';

  constructor(
    private currencyPipe: CurrencyPipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    if(this.model){
      //Initialize value - reference for input focus event and model
      let valueIsNumber = this.model[this.fieldName];
      this.inputValue = this.model[this.fieldName];

      if(valueIsNumber > 0){
        this.inputValue = valueIsNumber.toString();
      }

      this.inputRef.nativeElement.value = this.formattedValue(this.inputValue);
    }
  }

  formattedValue(value: any) {
    let finalFormat = '';

    if(value && value.length > 0){
      const newValue = value.replace(this.decimalDutch, this.decimal); //Example: 123456,1000 ===> 123456.1000
      let formatted  = this.currencyPipe.transform(newValue, '€', 'symbol', '1.2-2'); //Expected €123,123.12

      // code below is to make it real currency formatting in Netherlands
      finalFormat = formatted.replace(this.decimal, '_'); //This trick is to replce the '.' to '_' first becuse the next line will be replacing all ',' to '.'
      finalFormat = finalFormat.replace(/,/g, this.decimal);
      finalFormat = finalFormat.replace('_', this.decimalDutch); //This part is to replace the '_' to ',' becuase this is the real decimal sign for dutch currency format
    }

    return finalFormat; //Expected display Example: 123.456,10
  }

  // Key press event
  numberOnlyValidation(event: any) {
    const pattern = /[0-9,]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
    
    if(inputChar === this.decimalDutch && event.srcElement.value.length >= 1) {
      let found = event.srcElement.value.search(inputChar);
      if(found >= 0){
        event.preventDefault();
      }
    }
  }

  // Key up event
  updateModel(event: any) {
    const { value } = event.srcElement;
    let newValue = '';
    
    if(value.length > 0){
      newValue = value.replace(this.decimalDutch, this.decimal); //Example: 123456,1000 ===> 123456.1000
    }else{
      newValue = ''; 
    }

    //Save reference for input focus event and model
    this.inputValue = newValue;
    this.model[this.fieldName] = newValue;
  }

  // Blur event
  format(event: any) {
    const { value } = event.srcElement;

    event.srcElement.value = this.formattedValue(value);
  }

  // Focus event
  toNumber(event: any) {
    if(this.inputValue) {
      let value = this.inputValue.replace(this.decimal, this.decimalDutch);
      event.srcElement.value = value;
    }
  }

}
